package ru.malygin.myConst

val adminToken = listOf(
    "789456asd241-admin-asd2345qw3qe1-asd1233qw3e"
)

const val PERIODIC_WORK_STATE = true

const val MAIN_DATABASE_NAME = "schedule_prk_main"
const val TEMPORARY_DATABASE_NAME = "schedule_prk_temporary"
const val SETTINGS_DATABASE_NAME = "settings_info"